import { MaiErrorKindLabel } from '~/analytics/maiChatEvents';

import { MaiChatErrorKind, MaiSuggestedPrompt } from './maiChat.types';

export const MAI_CHAT_ERROR_NETWORK =
  "Couldn't reach Maud. Check your connection and try again.";
export const MAI_CHAT_ERROR_AGENT =
  'Maud ran into a problem generating that response.';
export const MAI_CHAT_ERROR_INTERRUPTED =
  'This answer stopped when you switched charts.';
export const MAI_CHAT_RETRY_CTA = 'Retry';

// Shared by the panel (Turn Retried) and the session context (Error Shown), so
// one kind reads the same on both events.
export const MAI_CHAT_ERROR_KIND_LABELS: Record<
  MaiChatErrorKind,
  MaiErrorKindLabel
> = {
  agent: 'Agent',
  interrupted: 'Interrupted',
  network: 'Network',
};

export const MAI_CHAT_HISTORY_ERROR = "Couldn't load past conversations.";
export const MAI_CHAT_HISTORY_LOADING = 'Loading past conversations…';

export const MAI_CHAT_JUMP_TO_LATEST = 'New content';

export const MAI_CHAT_DISCLAIMER =
  'Maud AI can make mistakes. Please double-check cited sources.';

// Rendered with mai-prompts-endpoint off, or when GET /mai/prompts fails.
export const MAI_SUGGESTED_PROMPTS: ReadonlyArray<MaiSuggestedPrompt> = [
  {
    id: 'summarize',
    label: 'Summarize Last 7 Days',
    text: 'Summarize Last 7 Days',
    icon: 'summary',
    rank: 0,
    category: 'recap',
  },
  {
    id: 'care-opportunities',
    label: 'Care Opportunities',
    text: 'Care Opportunities',
    icon: 'opportunity',
    rank: 1,
    category: 'opportunity',
  },
  {
    id: 'recent-assessments',
    label: 'Recent Assessments',
    text: 'Recent Assessments',
    icon: 'assessment',
    rank: 2,
    category: 'assessment',
  },
  {
    id: 'celebrate-wins',
    label: 'Celebrate Wins',
    text: 'Summarize clinical wins and progress in 2–4 short bullet points covering assessments, weight trends, session attendance, safety screens, meal logging, and care plan behavior frequency improvements. If data is unavailable for a category, skip it.',
    icon: 'celebration',
    rank: 3,
    category: 'progress',
  },
];

// Friendly labels for known tools; unknown tools fall back via toolCallLabel.
export const MAI_CHAT_TOOL_LABELS: Record<string, string> = {
  getAssessments: 'Reviewing assessments',
  getClinicalProfile: 'Reading clinical profile',
  getGroupedAssessments: 'Reviewing assessments',
  getObservations: 'Reviewing observations',
  getPatientById: 'Loading patient chart',
  getSmtSummary: 'Reviewing SMT meal logs',
  getWeightsVitals: 'Reading weight & vitals',
  get_transcripts: 'Reading session transcripts',
  retrieveClinicalProtocol: 'Searching clinical protocols',
};

export const MAI_CHAT_TOOL_FALLBACK_PREFIX = 'Getting ';
